import { render, staticRenderFns } from "./ScoringModelEdit.vue?vue&type=template&id=516924a9&scoped=true&lang=pug&"
import script from "./ScoringModelEdit.vue?vue&type=script&lang=js&"
export * from "./ScoringModelEdit.vue?vue&type=script&lang=js&"
import style0 from "./ScoringModelEdit.vue?vue&type=style&index=0&id=516924a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516924a9",
  null
  
)

/* custom blocks */
import block0 from "./ScoringModelEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports